import * as React from 'react';

interface IIconStep extends React.DetailedHTMLProps<React.SVGAttributes<SVGElement>, SVGElement> {
  step: number;
}

export const IconStep = (props: IIconStep) => {
  const { step, ref, ...rest  } = props;

  return (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51">
      <g fillRule="evenodd">
        {renderPath(step)}
        <text fontFamily="Lato-Heavy, Lato" fontSize="26" fontWeight="600">
          <tspan x="18" y="33">{step}</tspan>
        </text>
      </g>
    </svg>

  );
};

const renderPath = (step: number) => {
  // tslint:disable:max-line-length
  switch (step) {
    case 1: return <path fillRule="nonzero" d="M39.325 7.425C10.385-12.298-10.265 19.238 8.078 42.66 26.422 66.08 68.266 27.148 39.325 7.425z"/>;
    case 2: return <path d="M48.467 27C58.652-9.05 3.55-3.992 1.667 22.743c-1.884 26.735 36.575 40.442 46.8 4.255z"/>;
    case 3: return <path fillRule="nonzero" d="M44.349 12.93c-23.936-28.85-50.06-.413-40.321 25.152 9.739 25.565 64.257 3.698 40.32-25.152z"/>;
    case 4: return <path fillRule="nonzero" d="M35.71 46.777C61.617 32.363 51.3-11.506 16.66 3.425c-34.639 14.932-6.857 57.766 19.05 43.352z"/>;
    case 5: return <path fillRule="nonzero" d="M46.102 16.904C26.024-15.336-.446 4.475 3.17 33.278 6.784 62.08 66.181 49.145 46.102 16.904z"/>;
    case 6: return <path fillRule="nonzero" d="M29.789.9C-2.973 4.203-11.294 40.432 20.7 49.265 52.694 58.098 62.55-2.403 29.789.9z"/>;
    default: return null;
  }
  // tslint:enable:max-line-length
}

